// extracted by mini-css-extract-plugin
export default {"root":"LanguageSelector_root__QEOdX","langOption":"LanguageSelector_langOption__BtrgP","popup":"LanguageSelector_popup__A7sZU"};